/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {
    export function meevoOrdinalNumberPrefixFilter() {
        const filter = (x: string | number): string => {
            switch (+x) {
                case 1:
                    return '1st';
                case 2:
                    return '2nd';
                case 3:
                    return '3rd';
                default:
                    return x + 'th';
            }
        };

        return filter;
    }

    angular.module('meevo.components.filters')
        .filter('meevoOrdinalNumberPrefix', meevoOrdinalNumberPrefixFilter);
}
